import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile'
import { forwardRef } from 'react'
import { useSettings } from '~/@mid_settings/settings'

type TurnstileWidgetProps = {
  onSuccess?: (token: string) => void
  onError?: () => void
  onExpire?: () => void
  onWidgetLoad?: () => void
  action?: string
}

const TurnstileWidget = forwardRef<TurnstileInstance, TurnstileWidgetProps>(
  ({ onSuccess, onError, onExpire, onWidgetLoad, action = 'submit' }, ref) => {
    const { turnstile } = useSettings()

    if (!turnstile.siteKey) return null

    return (
      <Turnstile
        ref={ref}
        siteKey={turnstile.siteKey}
        onSuccess={onSuccess}
        onError={onError}
        onExpire={onExpire}
        onWidgetLoad={onWidgetLoad}
        options={{
          size: 'normal',
          execution: 'execute',
          appearance: 'interaction-only',
          action,
        }}
      />
    )
  }
)

TurnstileWidget.displayName = 'TurnstileWidget'

export { TurnstileWidget }
